/** Compact vertical padding for navy profile section headers (Business Overview, etc.) */
export const PROFILE_SECTION_HEADER_PY = { base: 6, sm: 8 } as const;

export const PROFILE_SECTION_HEADER_PX = { base: "md", sm: "xl" } as const;

export const PROFILE_SECTION_HEADER_ICON_SIZE = 18;

export const PROFILE_SECTION_HEADER_TITLE_FZ = "sm" as const;

/** Vertical space between stacked profile section cards */
export const PROFILE_SECTION_GAP = 10;
